import {
  WorkScheduleEntity,
  WorkScheduleFilter,
} from '../../models/workSchedule/workSchedule'

export const SET_WORK_SCHEDULES = 'SET_WORK_SCHEDULES'
export const SET_WORK_SCHEDULES_LOADED = 'SET_WORK_SCHEDULES_LOADED'
export const SET_SELECTED_WORK_SCHEDULE = 'SET_SELECTED_WORK_SCHEDULE'
export const SET_WORK_SCHEDULE_FILTER = 'SET_WORK_SCHEDULE_FILTER'

export interface WorkScheduleState {
  workSchedules: WorkScheduleEntity[]
  isWorkSchedulesLoaded: boolean
  selectedWorkSchedule?: WorkScheduleEntity
  workScheduleFilter: WorkScheduleFilter
}

interface SetWorkSchedulesAction {
  type: typeof SET_WORK_SCHEDULES
  payload: WorkScheduleEntity[]
}

interface SetWorkSchedulesLoadedAction {
  type: typeof SET_WORK_SCHEDULES_LOADED
  payload: boolean
}

interface SetSelectedWorkScheduleAction {
  type: typeof SET_SELECTED_WORK_SCHEDULE
  payload?: WorkScheduleEntity
}

interface SetWorkScheduleFilterAction {
  type: typeof SET_WORK_SCHEDULE_FILTER
  payload: WorkScheduleFilter
}

export type WorkScheduleAction =
  | SetWorkSchedulesAction
  | SetWorkSchedulesLoadedAction
  | SetSelectedWorkScheduleAction
  | SetWorkScheduleFilterAction
